import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import BasicTable from "componentsv2/table/BasicTable";
import Selection from "componentsv2/form/Selection";
import { layout as modelCharge } from "./models/modelCharge";
import { getStorage } from "store/local";
import { useTable } from "storev2/tableStore";
import { genStoreId } from "componentsv2/tools/functions";
import proxy from "api/proxy";

// function layout() {
//   const ctxView = {
//     model: "hotel.booking.update_taxes.start",
//     selectable: false, // options: multi - one - false
//     limit: null,
//     form_action: ["open"],
//     table_action: ["open"],
//     fields: {},
//     form: [],
//   };
//   return ctxView;
// }

async function searchTaxesOptions() {
  const hotelConfig = getStorage("hotelConfig");
  const taxes = hotelConfig["taxes_auth."];
  const res = taxes.map((tax) => {
    return { id: tax.id, name: tax.rec_name };
  });
  return res;
}

function WizardUpdateTaxes({ layout, onClose }) {
  const charges = useSignal([]);
  const taxes = useSignal(null);
  const tax = useSignal();

  const storeId = genStoreId(layout.model, null);

  async function onChange(fieldName, value) {
    console.log("onChange...", fieldName, value);
  }

  async function searchCharges(storeId) {
    // Search charges for the given storeId
  }

  const fieldTax = {
    name: "tax",
    label: "hotel.charge.tax",
    type: "selection",
    onChange: onChange,
    options: taxes.value,
    data: tax,
    // label: "hotel.booking.add_room.arrival_date",
  };

  useEffect(() => {
    async function fetchData() {
      // const options = await searchTaxesOptions();
      // setCtxViewUpdate({
      //   ...ctxViewUpdate,
      //   webfields: {
      //     ...ctxViewUpdate.webfields,
      //     taxes: { type: "selection", options: options },
      //   },
      // });
      // setDomain([
      //   ["folio.booking", "=", record.id],
      //   ["invoice_line", "=", null],
      // ]);
      taxes.value = await searchTaxesOptions();
    }
    fetchData();
  }, []);

  async function handleAccept(storeId) {
    // Update taxes in charges selected for the given storeId
    const { [storeId]: currentTable } = useTable.getState();
    const selected = currentTable.selectedRows;
    if (tax.value && selected?.size > 0) {
      const charges_ids = Array.from(selected.keys());
      const args = {
        model: "hotel.folio.charge",
        ids: charges_ids,
        values: { taxes: [["add", [tax.value.id]]] },
      };

      const { error } = await proxy.save(args);
      // reset();
    }
    onClose();
  }

  return (
    <div className="">
      <div className="my-4 w-2/3 lg:w-1/2b">
        <Selection {...fieldTax} data={taxes} />
      </div>
      <BasicTable storeId={storeId} layout={modelCharge()} records={charges} />
    </div>
  );
}

export default WizardUpdateTaxes;
